import type { DeepRequired } from '../fixtures.types'

const clientAddress: DeepRequired<ClientAddress> = {
  __typename: 'ClientAddress',
  id: 'TEST_ID',
  address: {
    __typename: 'LutherAddress',
    acre_property_id: null,
    address1: null,
    address2: null,
    address3: null,
    county: null,
    postcode: null,
    country: null,
    posttown: null,
  },
  document_verifies: null,
  documents: [],
  internalHash: null,
  is_current_correspondence: true,
  move_in_date: null,
  move_out_date: null,
  property_location: null,
  residential_status: null,
}

export default clientAddress
